import React from "react";
import Parser from "html-react-parser";
import Popup from "../Popup";
import Image from "../../UI/Images/Image";
import "./popupError.scss";

class PopupError extends Popup {

    constructor(props) {
        super(props);
    }

    render() {


        return (
            <div className={"pp-popup pp-popup-error"} ref={this.ref}>
                <div className={"overlay"} />
                <div className={"box"}>
                    <div className={"js-close close"}>
                        <Image src={`${process.env.PUBLIC_URL}/assets/images/svg/close.svg`} />
                    </div>
                    <div className={"content"}>
                        <Image src={`${process.env.PUBLIC_URL}/assets/images/svg/error.svg`}/>
                    <span className={"title"}>Ошибка!</span>
                    <span className={"subtitle"}>{Parser(this.props.message)}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default PopupError;
